import { boolean, number, route, string, union } from "react-router-typesafe-routes";

export const connectParams = route({
  searchParams: {
    ordering: union(["completion_rate", "rating", "gigs_worked"]),

    is_favorite: boolean(),
    is_verified: boolean(),
    has_worked_together: boolean(),
    has_background_check: boolean(),

    rating_gte: number(),
    time_blocks: number().defined().array(),
    certifications: number().defined().array(),
    pro_certifications: string().defined().array(),
    days_of_week: string().defined().array(),
    hours_per_week: number().defined().array(),
    contractor_types: number().defined().array(),
    previous_positions: number().defined().array(),
    badge_types: string().defined().array(),

    pro_fullname: string(),
    skill_group: string(),
  },
});

export const directOfferParams = route({
  searchParams: {
    offerType: union(["select", "existing"]),
  },
});
